// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root___ZZu1","header":"ReportDetails_header__1CBGv","title":"ReportDetails_title__zbFcY","left":"ReportDetails_left__1iHSM"};